import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { ChevronRight, Calendar } from "lucide-react";
import { Badge } from "../components/ui/badge";
import { API, BACKEND_URL } from "../config";
import Footer from "./components/Footer";

export default function NewsArticlePage() {
  const { slug } = useParams();
  const [article, setArticle] = useState(null);
  useEffect(() => { axios.get(`${API}/news/${slug}`).then(res => setArticle(res.data)).catch(console.error); }, [slug]);

  if (!article) return <div className="min-h-screen pt-32 flex items-center justify-center"><div className="animate-spin w-8 h-8 border-2 border-primary border-t-transparent rounded-full" /></div>;

  return (
    <>
    <div className="min-h-screen pt-24 sm:pt-32 pb-32 px-4 sm:px-6 md:px-12 lg:px-24" data-testid="news-article-page">
      <div className="max-w-3xl mx-auto">
        <Link to="/hirek" className="inline-flex items-center text-muted-foreground hover:text-primary text-sm mb-6"><ChevronRight className="h-4 w-4 mr-1 rotate-180" />Vissza a hírekhez</Link>
        <article className="animate-fade-in">
          <div className="mb-6">
            <Badge className="bg-primary/20 text-primary mb-3">{article.category}</Badge>
            <h1 className="text-2xl sm:text-4xl font-bold font-['Syne'] tracking-tight mb-4">{article.title}</h1>
            <div className="flex items-center gap-4 text-sm text-muted-foreground">
              <span className="flex items-center gap-2"><Calendar className="h-4 w-4" />{new Date(article.published_at).toLocaleDateString('hu-HU', { year: 'numeric', month: 'long', day: 'numeric' })}</span>
              <span>•</span><span>{article.author}</span>
            </div>
          </div>
          <div className="rounded-xl overflow-hidden mb-6">
            <img src={`${BACKEND_URL}/storage/${article.image}`} alt={article.title} className="w-full aspect-video object-cover" />
          </div>
          <div className="prose prose-invert max-w-none text-muted-foreground [&_p]:leading-relaxed [&_p]:mb-4 [&_p]:text-sm sm:[&_p]:text-base" dangerouslySetInnerHTML={{ __html: article.content || '' }} />
        </article>
      </div>
    </div>
    <Footer />
    </>
  );
}
